"use strict"; // Copyright 2018, Google, LLC.
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _classCallCheck = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/Drew/Desktop/338/daily-briefing/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable no-any

var GaxiosError =
/*#__PURE__*/
function (_Error) {
  _inherits(GaxiosError, _Error);

  function GaxiosError(message, options, response) {
    var _this;

    _classCallCheck(this, GaxiosError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GaxiosError).call(this, message));
    _this.response = response;
    _this.config = options;
    _this.code = response.status.toString();
    return _this;
  }

  return GaxiosError;
}(_wrapNativeSuper(Error));

exports.GaxiosError = GaxiosError;